<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item" (click)="choose(item.id)">
            <span style="cursor:pointer"  [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <app-date [type]="true"  [time]="time" [timeset]="timeset" (rangeSelected)="handleRangeSelected($event)"></app-date>
    <span *ngIf="now!='3'">
        性別篩選
        <select class="form-control" style="width: 160px;display: inline-block;" [(ngModel)]="tool_obj.gender" (change)="pageobj.page=0;init_list()">
            <option *ngFor="let item of gender_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        經紀篩選
        <select *ngIf="tool_obj.gender=='2'" class="form-control" style="width: 160px;display: inline-block;" [(ngModel)]="tool_obj.vid" (change)="pageobj.page=0;init_list()">
            <option *ngFor="let item of v_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <a href="{{urltoken}}" *ngIf="urltoken.length>0 && data.length>0" style="margin:10px;font-size: 20px;"  target="_blank">
            <i class="fa fa-download"></i>
        </a>
    </span>
</div>
   


<div *ngIf="data.length > 0">
    <app-table-v2 [type]="1" [pageobj]="pageobj" [data]="data" [tcontent]="tcontent" (countp)="handlepage($event)"  (sortdata)="handlesortdata($event)"></app-table-v2>
</div>
<div style="width: 80%;">
    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
</div>
<div *ngIf="data.length==0">無資料</div>
<app-spinner [loading]="loading"></app-spinner>

